// Pure helpers for the Test Phone page and its page notes (SUN-88).
export const PHONE_AREA_ID = 'test-phone-area';
export const PHONE_ROUTE = '/dev/test-phone';

interface Box { x: number; y: number; width: number; height: number }
export interface AnnotationBits { elementPath?: string; fullPath?: string; boundingBox?: Box }
interface Rect { left: number; top: number; right: number; bottom: number }

/** Was this note drawn inside the phone area? The element path names the area, or the note's box centre is inside it. */
export function inPhoneArea(a: AnnotationBits, area: Rect | null, scroll: { x: number; y: number } = { x: 0, y: 0 }): boolean {
  if (`${a.fullPath ?? ''} ${a.elementPath ?? ''}`.includes(PHONE_AREA_ID)) return true;
  if (!area || !a.boundingBox) return false;
  const cx = a.boundingBox.x + a.boundingBox.width / 2, cy = a.boundingBox.y + a.boundingBox.height / 2;
  const within = (x: number, y: number) => x >= area.left && x <= area.right && y >= area.top && y <= area.bottom;
  // agentation keeps y in page coordinates (viewport + scroll) for ordinary elements and viewport coordinates for fixed ones
  return within(cx, cy) || within(cx - scroll.x, cy - scroll.y);
}

export interface PhoneScreenNow { package: string | null; activity: string | null }
/** Dots show on the phone only while the same package AND activity is on screen. */
export function sameScreen(note: { phone?: { package: string | null; activity: string | null } | null }, now: PhoneScreenNow | null): boolean {
  const p = note.phone;
  return !!p && !!now && !!p.package && p.package === now.package && p.activity === now.activity;
}

/** "10:45" in India time, for the log and "since". */
export function clockIst(ms: number): string {
  return new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).format(new Date(ms));
}

/** The page a "My notes" click should open for a note: the Test Phone page (and its app) for a phone note. */
export function phoneNoteTarget(n: { route: string; phone?: { appKey: string | null } | null }): string | null {
  if (!n.phone) return null;
  return n.phone.appKey ? `${PHONE_ROUTE}?open=${encodeURIComponent(n.phone.appKey)}` : PHONE_ROUTE;
}

export function ageText(idleMs: number): string {
  const m = Math.floor(idleMs / 60_000);
  return m < 1 ? 'just now' : m === 1 ? '1 min ago' : `${m} min ago`;
}
